const ClaimsDataTable = ({ title, columns = [], rows = [], loading = false }) => {
  const skeletonRows = 5;

  // Map column types to Tailwind text colors & font
  const getCellClass = (col) => {
    const lowerCol = col.toLowerCase();
    if (lowerCol.includes("name")) return "font-fig-semibold text-gray-800";
    if (lowerCol.includes("cashless")) return "text-green-500";
    if (lowerCol.includes("reimbursement")) return "text-blue-600";
    if (lowerCol.includes("value") || lowerCol.includes("amount")) return "font-fig-semibold";
    return "text-gray-600 font-fig-regular";
  };

  return (
    <div className="bg-white p-6 mb-6 border border-gray-200 rounded-lg shadow-sm">
      <h2 className="text-lg font-fig-semibold text-gray-800 mb-4">{title}</h2>
      <div className="overflow-x-auto">
        <table className="w-full table-auto text-left border-separate border-spacing-y-1">
          <thead>
            <tr className="bg-gray-50">
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="py-3 px-4 text-sm font-fig-semibold text-gray-700 border-b border-gray-200"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading
              ? Array.from({ length: skeletonRows }).map((_, idx) => (
                  <tr key={idx} className="bg-gray-50 animate-pulse">
                    {columns.map((_, cIdx) => (
                      <td key={cIdx} className="py-3 px-4 text-sm">
                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                      </td>
                    ))}
                  </tr>
                ))
              : rows.map((row, idx) => (
                  <tr
                    key={idx}
                    className={`transition-all duration-200 ${
                      idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-blue-50`}
                  >
                    {columns.map((col, cIdx) => {
                      const cellContent = row[col] ?? "-";
                      const cellClass = getCellClass(col);

                      return (
                        <td key={cIdx} className={`py-3 px-4 text-sm ${cellClass}`}>
                          {cellContent}
                        </td>
                      );
                    })}
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClaimsDataTable;
